"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Anchor = void 0;
exports.prepareLinks = prepareLinks;
var _react = _interopRequireDefault(require("react"));
var _RouteLinks = _interopRequireDefault(require("./RouteLinks"));
function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}
function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);
  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    enumerableOnly && (symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    })), keys.push.apply(keys, symbols);
  }
  return keys;
}
function _objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = null != arguments[i] ? arguments[i] : {};
    i % 2 ? ownKeys(Object(source), !0).forEach(function (key) {
      _defineProperty(target, key, source[key]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) {
      Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
    });
  }
  return target;
}
function _defineProperty(obj, key, value) {
  key = _toPropertyKey(key);
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }
  return obj;
}
function _toPropertyKey(arg) {
  var key = _toPrimitive(arg, "string");
  return typeof key === "symbol" ? key : String(key);
}
function _toPrimitive(input, hint) {
  if (typeof input !== "object" || input === null) return input;
  var prim = input[Symbol.toPrimitive];
  if (prim !== undefined) {
    var res = prim.call(input, hint || "default");
    if (typeof res !== "object") return res;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return (hint === "string" ? String : Number)(input);
}
/**
 prepareLinks function find all "link" and "labelLink" properties,
 and replace place holders like {program_id} with actual value in data[program_id]
 It return a new properties array with new values
 */
function prepareLinks(properties, data) {
  return properties.map(function (prop) {
    var newProp = _objectSpread({}, prop);
    var pattern = /{(.*)}/;
    if (prop.link) {
      newProp.link = prop.link.replace(pattern, function (match, p1) {
        return data[p1];
      });
    }
    if (prop.labelLink) {
      newProp.labelLink = prop.labelLink.replace(pattern, function (match, p1) {
        return data[p1];
      });
    }
    return newProp;
  });
}

/**
 * Anchor component create internal links as well as external links
 * External links must contain URL scheme, such as "https://"
 * Other links will be treated as React internal links
 * @param link: link URL or path
 * @param text: test for the link
 * @param classes: style object, must contain styles for class "link"
 * @returns React component contains the link
 * @constructor
 */
var Anchor = function Anchor(_ref) {
  var link = _ref.link,
    text = _ref.text,
    classes = _ref.classes;
  return link.match(/\w+:\/\//) ? /*#__PURE__*/_react.default.createElement("a", {
    href: link,
    target: "_blank",
    rel: "noopener noreferrer",
    className: classes.link
  }, text) : /*#__PURE__*/_react.default.createElement(_RouteLinks.default, {
    to: link,
    className: classes.link
  }, text);
};
exports.Anchor = Anchor;